import React from "react";
import { WorkflowIcon, GitForkIcon, ActivityIcon, FolderOpenIcon, ListChecksIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { toolkit } from "../data/content";
const icons = [WorkflowIcon, GitForkIcon, ActivityIcon, FolderOpenIcon, ListChecksIcon];
export function Toolkit() {
  return <section className="bg-night px-4 py-16 sm:px-6 sm:py-20" data-id="element-286" data-mp="avpzp9zokom7">
      <div className="mx-auto max-w-4xl" data-id="element-287" data-mp="au55xml6x9pe">
        <SectionHeading dark kicker="Your complete diagnostic toolkit" title="Practical resources to apply the framework to your own cases" data-id="element-288" data-mp="5wn2uctutopb" />

        <ul className="mt-10 divide-y divide-white/10 rounded-3xl bg-white/5 px-5 sm:px-8" data-id="element-289" data-mp="krjlljzahugn">
          {toolkit.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex gap-4 py-6" data-id="element-290" data-mp="2mnd5ck6hybgj" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand text-white" data-id="element-291" data-mp="2hn7mnti7fzal">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-292" data-mp="201s36dvzxujv" />
                </span>
                <div data-id="element-293" data-mp="242lrv9h9jddt">
                  <h3 className="font-display text-xl font-bold text-white" data-id="element-294" data-mp="242277l08aaw3">{t.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-white/75" data-id="element-295" data-mp="28zc8pz0w6d0a">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 text-center text-sm leading-relaxed text-white/60" data-id="element-296" data-mp="2irhw0vg78695">
          The complete system is designed to help you organize your diagnostic work—not replace your training,
          judgment, or manufacturer-specific service information.
        </p>

        <div className="mt-10" data-id="element-297" data-mp="2wqhj3yo2cd37">
          <CtaButton label="I want the complete toolkit" arrow data-id="element-298" data-mp="2wpevq0py8ss1" />
        </div>
      </div>
    </section>;
}